import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

import Economic from '../../Assets/Icons/Home/economic.svg';
import Customer from '../../Assets/Icons/Home/customer.svg';
import Environmental from '../../Assets/Icons/Home/environmental.svg';
import Innovation from '../../Assets/Icons/Home/innovation.svg';
import Sustainability from '../../Assets/Icons/Home/sustainability.svg';
import Partners from '../../Assets/Icons/Home/partners.svg';

import 'swiper/css';
import 'swiper/css/navigation';
import {
  ArrowLeftOutlined,
  LeftOutlined,
  RightOutlined,
  SwapLeftOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';

export default function ValuesSlider() {
  const { t } = useTranslation();
  const items = t('home.values.items', { returnObjects: true });
  const { language } = useSelector((state) => state.lang);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const [dir, setDir] = useState(language === 'ar' ? 'rtl' : 'ltr');

  const isRTL = dir === 'rtl';

  useEffect(() => {
    setDir(language === 'ar' ? 'rtl' : 'ltr');
  }, [language]);

  const images = [
    Customer,
    Environmental,
    Innovation,
    Sustainability,
    Partners,
  ];

  return (
    <section className="home__values">
      <h2>{t('home.values.title')}</h2>

      <div style={{ position: 'relative' }}>
        <Swiper
          key={isRTL ? 'rtl' : 'ltr'} //
          dir={dir}
          rtl={isRTL}
          modules={[Navigation, Autoplay]}
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false, // Keeps autoplay after user interacts
          }}
          spaceBetween={1}
          slidesPerView={2}
          breakpoints={{
            1024: { slidesPerView: 3 },
          }}
          onBeforeInit={(swiper) => {
            if (typeof swiper.params.navigation !== 'boolean') {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }
          }}
          onInit={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index} dir={dir}>
              <div className="home__values-item">
                <img src={images[index]} alt={item.label} loading="lazy" />
                <h3>{item.label}</h3>
                <p>{item.value}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Buttons */}
        <button
          className="home_button--left"
          ref={prevRef}
          style={{
            backgroundColor: isBeginning ? '#dfdfdf' : '#60EC2F',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: isBeginning ? 'not-allowed' : 'pointer',
            // zIndex: 10,
          }}
        >
          <LeftOutlined />
        </button>

        <button
          className="home_button--right"
          ref={nextRef}
          style={{
            backgroundColor: isEnd ? '#dfdfdf' : '#60EC2F',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: isEnd ? 'not-allowed' : 'pointer',
            // zIndex: 10,
          }}
        >
          <RightOutlined />
        </button>
      </div>
    </section>
  );
}
